<template>
    <div class="section">
        <div class="container section-about">
            <div class="text-box">
                <h2>「予防めし」とは</h2>
                <div class="btn-group">
                    <btnRounded to="./yobomeshi/about" class="b1 white small font-middle">コンセプト</btnRounded>
                    <btnRounded to="./yobomeshi/movie" class="b2 black small font-middle"
                    v-if="pagename == 'recipe'">ムービーギャラリー</btnRounded>
                    <btnRounded to="./yobomeshi" class="b3 white small font-middle"
                    v-if="pagename == 'movie'">みんなのレシピ</btnRounded>
                </div>
            </div>
            <div class="video-wrap">
                <a class="video-btn" @click="emit()">
                    <IconPlay />
                </a>
                <img src="@/assets/video-thumb.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import IconPlay from '@/assets/icon-play.svg?inline'
import btnRounded from '@/components/parts/btn-rounded.vue'

export default {
    name: 'page-about',
    props:{
        pagename: String
    },
    components:{
        IconPlay,
        btnRounded
    },
    methods:{
        emit(){
            this.$emit('clicked');
        }
    }
}
</script>

<style lang="scss" scoped>
.section{
    .section-about{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: stretch;
        max-width: calc(856px - 40px);
        padding-top: 200px;
        padding-bottom: 200px;
        padding-left: 20px;
        padding-right: 20px;
        @media #{$maxM}{
            flex-flow: column;
            justify-content: center;
            align-items: center;
            padding-top: 80px;
            padding-bottom: 160px;
        }
            .text-box{
                width: calc(42% - 20px);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                @media #{$maxM}{
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                }
                h2{
                    font-size: 2.32em;
                    letter-spacing: 0.2em;
                    white-space: nowrap;
                    margin-left: -0.5em;
                    margin-top: 0.2em;
                    @media #{$maxM}{
                        margin-top: 0;
                    }
                }
                .btn-group{
                    @media #{$maxM}{
                        margin-bottom: 60px;
                    }
                    .btn{
                        margin-top: 20px;
                        &:first-child{
                            margin-top: 0;
                            @media #{$maxM}{
                                margin-top: 34px;
                            }
                        }
                        &.b1{
                            width: calc(290px - 79px - 107px);
                            padding-left: 79px;
                            padding-right: 107px;
                        }
                        &.b2{
                            width: calc(290px - 36px - 64px);
                            padding-left: 36px;
                            padding-right: 65px;
                        }
                        &.b3{
                            width: calc(290px - 59px - 83px);
                            padding-left: 59px;
                            padding-right: 83px;  
                        }
                    }
                }
            }
            .video-wrap{
                width: calc(58% - 20px);
                @media #{$maxM}{
                    width: 100%;
                }
                .video-btn{
                    width: 66px;
                    height: 66px;
                    @media #{$maxM}{
                        width: 50px;
                        height: 50px;
                    }
                }
            }

    }
}
</style>